import { i18next, utils } from '@yola/ws-sdk';

const { isEmail } = utils.validation;

const createMailValidator = () => (value) => {
  if (!value) {
    return i18next.t('Invalid email. The email can not be empty');
  }

  if (!isEmail(value.trim())) {
    return i18next.t('Invalid email. Please, check the email and try again');
  }

  return null;
};

export default createMailValidator;
